// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { CANNOT_BE_IN_THE_FUTURE } from 'errors'

const validateDateHasPassed = v => (
  v.valueOf() > Date.now() && CANNOT_BE_IN_THE_FUTURE
)

export default validateDateHasPassed
